import { render, staticRenderFns } from "./COAAddClassModal.vue?vue&type=template&id=3c9ed838&scoped=true&"
import script from "./COAAddClassModal.vue?vue&type=script&lang=js&"
export * from "./COAAddClassModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9ed838",
  null
  
)

export default component.exports